import * as Yup from 'yup';

import { userNameSchema } from '../core/username/Username.schema';
import { passwordSchema } from '../core/password/Password.schema';

const credentialsSchema = () => Yup.object().concat(userNameSchema()).concat(passwordSchema());

export default credentialsSchema;
